/*
 * お気に入り（独自実装）
 *
 * 保存先はブラウザの localStorage。
 * ログイン連携（端末間同期）を後から足せるよう、保存処理は Wishlist.adapter に集約している。
 * サーバー側（App Proxy 等）を用意したら adapter を差し替えるだけで同期版になる。
 *   例) Wishlist.adapter = { load(){...}, save(handles){...} }
 */
window.Wishlist = (function () {
  var KEY = 'shomei_wishlist';
  var EVENT = 'wishlist:change';

  // ---- 保存アダプタ（既定: localStorage） ----
  var localAdapter = {
    load: function () {
      try {
        var raw = window.localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    },
    save: function (handles) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(handles));
      } catch (e) {
        /* プライベートモード等では保存できない。動作は継続する */
      }
      return Promise.resolve(handles);
    },
  };

  var adapter = localAdapter;
  var items = adapter.load();

  function emit() {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { items: items.slice() } }));
  }

  function persist() {
    var result = adapter.save(items.slice());
    emit();
    return result && result.then ? result : Promise.resolve(items.slice());
  }

  return {
    EVENT: EVENT,

    get adapter() {
      return adapter;
    },
    // 同期版に差し替えるための入口
    set adapter(next) {
      adapter = next || localAdapter;
      var loaded = adapter.load();
      if (loaded && loaded.then) {
        loaded.then(function (list) {
          items = Array.isArray(list) ? list : [];
          emit();
        });
      } else {
        items = Array.isArray(loaded) ? loaded : [];
        emit();
      }
    },

    all: function () {
      return items.slice();
    },
    count: function () {
      return items.length;
    },
    has: function (handle) {
      return items.indexOf(handle) !== -1;
    },
    add: function (handle) {
      if (!handle || this.has(handle)) return Promise.resolve(items.slice());
      items.unshift(handle);
      return persist();
    },
    remove: function (handle) {
      var i = items.indexOf(handle);
      if (i === -1) return Promise.resolve(items.slice());
      items.splice(i, 1);
      return persist();
    },
    toggle: function (handle) {
      return this.has(handle) ? this.remove(handle) : this.add(handle);
    },
    clear: function () {
      items = [];
      return persist();
    },
  };
})();

/* ---- ♡ボタンの共通挙動 ---- */
(function () {
  function syncButton(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    var on = window.Wishlist.has(handle);
    btn.classList.toggle('is-added', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('.wishlist_btn_txt');
    if (label) label.textContent = on ? btn.dataset.labelOn || 'お気に入り登録済み' : btn.dataset.labelOff || 'お気に入りに追加';
    var icon = btn.querySelector('i');
    if (icon) {
      icon.classList.toggle('fa-solid', on);
      icon.classList.toggle('fa-regular', !on);
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(syncButton);
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function (b) {
      var n = window.Wishlist.count();
      b.textContent = n;
      b.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.Wishlist.toggle(btn.getAttribute('data-wishlist-handle'));
  });

  document.addEventListener(window.Wishlist.EVENT, syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();

  // 別タブでの変更を反映
  window.addEventListener('storage', function (e) {
    if (e.key === 'shomei_wishlist') {
      window.Wishlist.adapter = window.Wishlist.adapter;
    }
  });
})();
